import {baseRequestService} from "../base.ts";

export const eventsEventIdVatsimPost = (eventId: string) => baseRequestService({
    url: `/events/${eventId}/vatsim`,
    method: 'POST',
})